import { render, staticRenderFns } from "./ad-chart-periods.vue?vue&type=template&id=569bd8a1"
import script from "./ad-chart-periods.vue?vue&type=script&lang=ts"
export * from "./ad-chart-periods.vue?vue&type=script&lang=ts"
import style0 from "./ad-chart-periods.vue?vue&type=style&index=0&id=569bd8a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports